export type RawCat = {
  url: string;
  src?: string;
  gif?: boolean;
  public_id?: string;
  width?: number;
  height?: number;
  moderated_at?: number;
};
export type CatItem = {
  url: string;
  src: string;
  gif: boolean;
  id: number;
  publicId?: string;
  width?: number;
  height?: number;
  moderatedAt?: number;
};

export type AppState = {
  allCats: CatItem[];
  filter: string;
  idx: number;
  nextId: number;
  loading: boolean;
  ended: boolean;
  offset: number;
};

export type IdState = { nextId: number };

export function mapBatch(
  raw: RawCat[],
  idState: IdState,
  existingUrls: ReadonlySet<string> = new Set(),
): CatItem[] {
  const seen = new Set(existingUrls);
  const out: CatItem[] = [];
  for (const c of raw) {
    const key = c.url;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({
      url: c.url,
      src: c.src || 'unknown',
      gif: Boolean(c.gif || /\.gif(\?|$)/i.test(c.url) || c.url.includes('/cat/gif')),
      id: idState.nextId++,
      publicId: c.public_id,
      width: c.width,
      height: c.height,
      moderatedAt: c.moderated_at,
    });
  }
  return out;
}

export function mapSingle(raw: RawCat, idState: IdState): CatItem {
  return mapBatch([raw], idState)[0];
}
